import { type RoleListItem, RoleMapper } from "@/models/role.model";
import type { GetRoleListPaginatedParams } from "@/spz-api/model";
import { getRoleListPaginated } from "@/spz-api/roles/roles";
import type { IRoleRepository } from "../interfaces/role-repository.interface";

export class RoleRepository implements IRoleRepository {
  async getRoles(params: GetRoleListPaginatedParams): Promise<RoleListItem[]> {
    const response = await getRoleListPaginated(params);
    return RoleMapper.toListItems(response.data);
  }
}
